import React from 'react';
import TimeTrackingContent from '../components/time-tracking';

const HomePage = () => {
  return <TimeTrackingContent />;
};

export default HomePage;
